// Client untuk TRMD JTAG (ws://localhost:8767).
import { BridgeClient, probeBridge } from "./bridge";

export const JLINK_ENGINE_URL = "ws://localhost:8767";

// Target yang sudah dipetakan. base/size = area flash utama.
// regions = seluruh area non-volatile yang bisa dibaca-balik untuk backup penuh.
// Catatan: BAM (serial bootloader NXP) ada di ROM internal, bukan flash — tidak bisa
// dibackup maupun dihapus, jadi tidak disertakan.
export const JLINK_TARGETS = [
  {
    id: "MPC5602D", label: "MPC5602D / SPC5602D · 256KB", base: 0, size: 0x40000,
    regions: [
      { name: "code-flash", base: 0x00000000, size: 0x40000 },
      { name: "data-flash", base: 0x00800000, size: 0x10000 },
      { name: "shadow-block", base: 0x00200000, size: 0x4000 },
    ],
  },
  { id: "MPC5604B", label: "MPC5604B · 512KB", base: 0, size: 0x80000,
    regions: [
      { name: "code-flash", base: 0x00000000, size: 0x80000 },
      { name: "data-flash", base: 0x00800000, size: 0x10000 },
      { name: "shadow-block", base: 0x00200000, size: 0x4000 },
    ],
  },
  { id: "MPC5606B", label: "MPC5606B · 1MB", base: 0, size: 0x100000,
    regions: [
      { name: "code-flash", base: 0x00000000, size: 0x100000 },
      { name: "data-flash", base: 0x00800000, size: 0x10000 },
      { name: "shadow-block", base: 0x00200000, size: 0x4000 },
    ],
  },
];

export const JLINK_SPEEDS = [4000, 2000, 1000, 500, 200, 100, 50];

const toHex = (u8) => Array.from(u8, (b) => b.toString(16).padStart(2, "0")).join("");

export async function pingJLinkEngine() {
  return probeBridge(JLINK_ENGINE_URL, 2500);
}

async function withEngine(fn) {
  const c = new BridgeClient(JLINK_ENGINE_URL);
  await c.connect();
  try { return await fn(c); } finally { try { c.ws && c.ws.close(); } catch (_) {} }
}

const base = (dll, device) => ({ dll, device });

export const jlinkConnect = (o, onProgress) =>
  withEngine((c) => c._rpc({ cmd: "jlinkConnect", ...base(o.dll, o.device), addr: o.addr || 0, rstPause: o.rstPause || 0 }, 600000, onProgress));

export const jlinkRead = (o, onProgress) =>
  withEngine((c) => c._rpc({ cmd: "jlinkRead", ...base(o.dll, o.device), addr: o.addr, size: o.size, rstPause: o.rstPause || 0 }, 3600000, onProgress));

export const jlinkErase = (o, onProgress) =>
  withEngine((c) => c._rpc({ cmd: "jlinkErase", ...base(o.dll, o.device), addr: o.addr || 0, rstPause: o.rstPause || 0 }, 900000, onProgress));

export const jlinkProgram = (o, bytes, onProgress) =>
  withEngine((c) => c._rpc({ cmd: "jlinkProgram", ...base(o.dll, o.device), addr: o.addr, verify: o.verify ? 1 : 0, erase: o.erase === false ? 0 : 1, rstPause: o.rstPause || 0, data: toHex(bytes) }, 3600000, onProgress));

export const jlinkReadMulti = (o, regions, onProgress) =>
  withEngine((c) => c._rpc({
    cmd: "jlinkReadMulti", ...base(o.dll, o.device), rstPause: o.rstPause || 0,
    regions: regions.map((r) => `${r.base}:${r.size}`).join(","),
  }, 3600000, onProgress));

export const jlinkVerify = (o, bytes, onProgress) =>
  withEngine((c) => c._rpc({ cmd: "jlinkVerify", ...base(o.dll, o.device), addr: o.addr, rstPause: o.rstPause || 0, data: toHex(bytes) }, 3600000, onProgress));

// Pemulihan censorship (shadow block). bytes opsional = isi shadow 16 KB dari backup.
export const mpcShadowRestore = (o, bytes, onProgress) =>
  withEngine((c) => c._rpc({ cmd: "mpcShadowRestore", ...base(o.dll, o.device), data: bytes ? toHex(bytes) : "" }, 900000, onProgress));

export const bamPorts = () => withEngine((c) => c._rpc({ cmd: "bamPorts" }, 15000));

export const bamProbe = (port, onProgress) =>
  withEngine((c) => c._rpc({ cmd: "bamProbe", port, baud: 19200 }, 60000, onProgress));
